import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  apiRoot: "",
  clientId: "",
  report: {
    attempts: 5,
    interval: 5e3
  }
};
const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setApiRoot(state, action) {
      state.apiRoot = action.payload;
    },
    setClientId(state, action) {
      state.clientId = action.payload;
    },
    setReportConfig(state, action) {
      state.report = action.payload;
    }
  }
});
const configActions = {
  ...configSlice.actions
};
export {
  configActions,
  configSlice
};
